import React, { useState, useEffect } from 'react';
import { getStatus, listDwAgents } from './claudeAgentApi';
import ClaudeAgentChatPage from './ClaudeAgentChatPage';
import ClaudeAgentRequestPage from './ClaudeAgentRequestPage';
import ClaudeAgentPendingPage from './ClaudeAgentPendingPage';
import './claudeagents.css';
const Bone: React.FC<{
    w: string | number;
    h: number;
    r?: number;
    style?: React.CSSProperties;
}> = ({ w, h, r = 8, style }) => (<div className="cac-skel__bone" style={{ width: w, height: h, borderRadius: r, flexShrink: 0, ...style }}/>);
const ChatPageSkeleton: React.FC = () => (<div className="cac-root">
    <main className="cac-main">
      <div className="cac-scroll">
        <div className="cac-feed">
          <div className="cac-welcome" style={{ pointerEvents: 'none' }}>

            
            <div className="cac-welcome__hero">
              <Bone w={44} h={44} r={13}/>
              <div className="cac-welcome__hero-text" style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                <Bone w="48%" h={20} r={8}/>
                <Bone w="28%" h={12} r={6}/>
              </div>
              <Bone w={96} h={24} r={20}/>
            </div>

            
            <div className="cac-welcome__body">

              
              <div className="cac-welcome__left">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 20 }}>
                  <Bone w="88%" h={12} r={6}/>
                  <Bone w="74%" h={12} r={6}/>
                  <Bone w="56%" h={12} r={6}/>
                </div>
                <div className="cac-welcome__features">
                  {[0, 1, 2, 3].map(i => (<div key={i} className="cac-welcome__feature-card" style={{ cursor: 'default' }}>
                      <Bone w={30} h={30} r={9} style={{ flexShrink: 0 }}/>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
                        <Bone w={`${[55, 62, 48, 58][i]}%`} h={11} r={5}/>
                        <Bone w={`${[72, 68, 76, 64][i]}%`} h={10} r={5}/>
                      </div>
                    </div>))}
                </div>
              </div>

              
              <div className="cac-welcome__right">
                
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <Bone w="30%" h={10} r={5}/>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                  {[0, 1, 2, 3].map(i => (<div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10,
            padding: '10px 12px', borderRadius: 10,
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                      <Bone w={28} h={28} r={8} style={{ flexShrink: 0 }}/>
                      <Bone w={`${[66, 72, 60, 68][i]}%`} h={11} r={5}/>
                    </div>))}
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        marginTop: 16, padding: '10px 0',
        borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                  <Bone w="40%" h={11} r={5}/>
                  <Bone w={18} h={18} r={5}/>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      
      <div className="cac-input-area">
        <div className="cac-input-box" style={{ pointerEvents: 'none' }}>
          <Bone w="100%" h={44} r={14}/>
        </div>
        <p className="cac-input-hint" style={{ textAlign: 'center', marginTop: 8 }}>
          <Bone w={180} h={11} r={5} style={{ margin: '0 auto' }}/>
        </p>
      </div>
    </main>
  </div>);
function dispatchOpenConfig(agentId: string) {
    window.dispatchEvent(new CustomEvent('showAgentConfigPanel', { detail: { agentId } }));
}
const STORAGE_KEY = 'claudeAgentsRequestStatus';
type Gate = 'loading' | 'none' | 'pending' | 'ready';
const ClaudeAgentsPage: React.FC = () => {
    const [gate, setGate] = useState<Gate>('loading');
    const [agentId, setAgentId] = useState<string | null>(null);
    useEffect(() => {
        let cancelled = false;
        getStatus()
            .then(async (s) => {
            if (cancelled)
                return;
            if (!s.configured) {
                localStorage.removeItem(STORAGE_KEY);
                setGate('none');
                return;
            }
            const agents = await listDwAgents(false, true).catch(() => []);
            if (cancelled)
                return;
            if (agents.length > 0) {
                localStorage.removeItem(STORAGE_KEY);
                setAgentId(agents[0].agent_id);
                setGate('ready');
            }
            else {
                localStorage.setItem(STORAGE_KEY, 'pending');
                setGate('pending');
            }
        })
            .catch(() => {
            if (cancelled)
                return;
            const local = localStorage.getItem(STORAGE_KEY);
            setGate(local === 'pending' ? 'pending' : 'none');
        });
        return () => { cancelled = true; };
    }, []);
    useEffect(() => {
        if (gate !== 'ready' || !agentId)
            return;
        const handler = () => dispatchOpenConfig(agentId!);
        window.addEventListener('openAgentConfig', handler);
        return () => window.removeEventListener('openAgentConfig', handler);
    }, [gate, agentId]);
    const handleActivated = (id: string) => {
        localStorage.removeItem(STORAGE_KEY);
        setAgentId(id);
        setGate('ready');
    };
    const handlePending = () => {
        localStorage.setItem(STORAGE_KEY, 'pending');
        setGate('pending');
    };
    if (gate === 'loading')
        return <ChatPageSkeleton />;
    if (gate === 'none')
        return <ClaudeAgentRequestPage onActivated={handleActivated} onPending={handlePending}/>;
    if (gate === 'pending')
        return <ClaudeAgentPendingPage />;
    return <ClaudeAgentChatPage agentId={agentId!}/>;
};
export default ClaudeAgentsPage;
